import { Model }                   from '@mathquis/modelx';
import ConfigProxy                 from '../../tools/ConfigProxy';
import { PlatformApiCsvConnector } from '../connectors/PlatformApiCsvConnector';

export const csvLsdConnector = new PlatformApiCsvConnector({
	baseURL: ConfigProxy.getServiceConfig('lsd', 'api_endpoint'),
});

export default class LsdApiCsvModel extends Model {
	static get connector() {
		return csvLsdConnector;
	}
}
